export const assets3dVal = '3D';
export const productVal = 'products';
export const allVal = 'all';
export const assets3dDisplayTxt = '3D Assets';
export const productDisplayTxt = 'Products';
export const allDisplayTxt = 'All';
//category values and index mapping for Tabs component
export const categorySelectionTabIndexMapping = {
	[assets3dVal]: 0,
	[productVal]: 1,
	[allVal]: 2,
};
export const showResultsGroupByType = 'Show results for...';

export const assets3dTabType = '3D Asset';
export const productsTabType = 'Product';

export const assets3dGroupByType = 'Go to Manage 3D Asset for...';
export const productsGroupByType = 'Go to Product Details for...';
